import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback, } from "react";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/components/common";
import { useNotificationsSignalR } from "@/hooks/useNotificationsSignalR";
const TOAST_DURATION_MS = 5000;
const NotificationContext = createContext(undefined);
export function useNotificationContext() {
    const ctx = useContext(NotificationContext);
    if (ctx === undefined) {
        throw new Error("useNotificationContext must be used within NotificationProvider");
    }
    return ctx;
}
/** Connects to notifications hub when mounted; only mount when user is authenticated. */
function NotificationSignalRConnector({ onNotificationCreated, }) {
    useNotificationsSignalR({
        onNotificationCreated,
        onConnectionError: () => { },
    });
    return null;
}
export function NotificationProvider({ children }) {
    const { user } = useAuth();
    const toast = useToast();
    const [latestNotification, setLatestNotification] = useState(null);
    const clearLatestNotification = useCallback(() => {
        setLatestNotification(null);
    }, []);
    const handleNotificationCreated = useCallback((payload) => {
        const message = payload.message?.trim() ?
            `${payload.title}: ${payload.message}`
            : payload.title;
        toast.info(message, TOAST_DURATION_MS);
        setLatestNotification(payload);
    }, [toast]);
    const value = {
        latestNotification,
        clearLatestNotification,
    };
    return (_jsxs(NotificationContext.Provider, { value: value, children: [user ? (_jsx(NotificationSignalRConnector, { onNotificationCreated: handleNotificationCreated })) : null, children] }));
}
